"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockCustomMenuItem = void 0;
var mockCustomMenuItem = {
  calories: 0,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: '',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'RegLg',
    imageURL: 'https://mobilestatic.littlecaesars.com/abcdefg.jpg'
  }],
  isCustomMenuItem: true,
  itemCaloriesText: '0',
  itemDescription: 'Create Your Own Pizza',
  itemDescriptionWithCalories: null,
  itemId: 601414,
  itemName: 'Create Your Own Pizza',
  itemNameWithCalories: '',
  itemType: 'LTO',
  maxToppings: 0,
  menuItemCode: 'BNR-CUS',
  menuItemHasBanner: false,
  menuWarnings: null,
  orderable: false,
  price: 0,
  selectedCustomOptions: null,
  selectedToppings: null,
  servings: '',
  sortOrder: 0,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null
};
exports.mockCustomMenuItem = mockCustomMenuItem;